import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UmbracoBlockConfiguration } from '../../models/umbraco-blocks.types';

@Component({
    selector: 'nw-umbraco-tint',
    template: `
        @if (tint() && tint() !== 'none') {
            <svg width="0" height="0">
                <filter [id]="id()" width="200%" height="200%">
                    <feColorMatrix
                        result="greyscale"
                        in="SourceGraphic"
                        type="matrix"
                        values="
              0.3333 0.3333 0.3333 0 0
              0.3333 0.3333 0.3333 0 0
              0.3333 0.3333 0.3333 0 0
              0      0      0      1 0 "
                    />
                    @if (tint() === 'blue') {
                        <feColorMatrix
                            in="greyscale"
                            result="inverted"
                            type="matrix"
                            values="
                  -1  0  0 0 1
                   0 -1  0 0 1
                   0  0 -1 0 1
                   0  0  0 1 0"
                        ></feColorMatrix>
                        <feColorMatrix
                            type="luminanceToAlpha"
                            in="inverted"
                            result="luminance"
                        ></feColorMatrix>
                        <feComponentTransfer
                            color-interpolation-filters="sRGB"
                            result="duotone"
                        >
                            <feFuncR
                                type="table"
                                tableValues="0.26666666666666666 0.35294117647058826"
                            ></feFuncR>
                            <feFuncG
                                type="table"
                                tableValues="0.38823529411764707 0.5725490196078431"
                            ></feFuncG>
                            <feFuncB
                                type="table"
                                tableValues="0.5372549019607843 0.7607843137254902 "
                            ></feFuncB>
                            <feFuncA type="table" tableValues="0 0.8"></feFuncA>
                        </feComponentTransfer>
                        <feComponentTransfer
                            color-interpolation-filters="sRGB"
                            in="duotone"
                            result="gamma"
                        >
                            <feFuncR
                                type="gamma"
                                exponent="1.5"
                                amplitude="1.3"
                                offset="0"
                            ></feFuncR>
                            <feFuncG
                                type="gamma"
                                exponent="1.5"
                                amplitude="1.3"
                                offset="0"
                            ></feFuncG>
                            <feFuncB
                                type="gamma"
                                exponent="1.5"
                                amplitude="1.3"
                                offset="0"
                            ></feFuncB>
                        </feComponentTransfer>
                        <feComposite operator="atop" in2="greyscale"></feComposite>
                    }
                </filter>
            </svg>
        }
    `,
    styles: `
        :host {
            order: 999;
            height: 0;
            width: 0;
            opacity: 0;
            pointer-events: none;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TintComponent {
    public tint = input.required<UmbracoBlockConfiguration.Tint>();
    public id = input.required<string>();
}
